/** `row + col` for each square, in row-major order, drives the diagonal wave. */
const DIAGONALS = [0, 1, 2, 1, 2, 3, 2, 3, 4];

/** Seconds each diagonal step is offset, so the crest travels top-left to bottom-right. */
const STEP_SECONDS = 0.12;

/** The static opacity each square holds when motion is reduced. */
const SNAPSHOT_OPACITY = [1, 0.66, 0.42, 0.26, 0.15];

export type PulseSquare = {
  /** Positive stagger offset; the loader negates it so the wave is mid-flight on first paint. */
  staggerSeconds: number;
  opacity: number;
};

export function pulseSquares(): PulseSquare[] {
  return DIAGONALS.map((diagonal) => ({
    staggerSeconds: diagonal * STEP_SECONDS,
    opacity: SNAPSHOT_OPACITY[diagonal],
  }));
}
